import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export enum FormType {
  None = 'none',
  Improvement = 'improvement',
  Feedback = 'feedback',
  OneOnOne = 'oneOnOne',
  PerformanceImprovement = 'performanceImprovement',
  VerbalWarning = 'verbalWarning',
  DisciplinaryAction = 'disciplinaryAction',
}

interface ActionsDropdownProps {
  userId?: string;
  userName?: string;
  isOpen: boolean;
  onToggle: () => void;
  onFormSelect: (formType: FormType, userId?: string, userName?: string) => void;
  isMainDropdown?: boolean;
}

const ActionsDropdown: React.FC<ActionsDropdownProps> = ({
  userId,
  userName,
  isOpen,
  onToggle,
  onFormSelect,
  isMainDropdown = false,
}) => {
  const renderMenuItems = () => {
    const targetUserId = isMainDropdown ? undefined : userId;
    const targetUserName = isMainDropdown ? undefined : userName;

    return (
      <>
        <DropdownItem onClick={() => onFormSelect(FormType.Feedback, targetUserId, targetUserName)}>
          <i className="fas fa-comment text-info mr-2" />
          Feedback
        </DropdownItem>
        <DropdownItem onClick={() => onFormSelect(FormType.OneOnOne, targetUserId, targetUserName)}>
          <i className="fas fa-users text-primary mr-2" />
          One on One
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem onClick={() => onFormSelect(FormType.PerformanceImprovement, targetUserId, targetUserName)}>
          <i className="fas fa-chart-line text-warning mr-2" />
          Performance Improvement
        </DropdownItem>
        <DropdownItem onClick={() => onFormSelect(FormType.VerbalWarning, targetUserId, targetUserName)}>
          <i className="fas fa-exclamation-triangle text-orange mr-2" />
          Verbal Warning
        </DropdownItem>
        <DropdownItem onClick={() => onFormSelect(FormType.DisciplinaryAction, targetUserId, targetUserName)}>
          <i className="fas fa-gavel text-danger mr-2" />
          Disciplinary Action Notice
        </DropdownItem>
      </>
    );
  };

  const dropdownProps = isMainDropdown
    ? {}
    : {
        isOpen,
        toggle: onToggle,
        style: { marginLeft: '10px' },
      };

  return (
    <UncontrolledDropdown {...dropdownProps}>
      {isMainDropdown ? (
        <DropdownToggle caret color="primary" size="sm">
          <i className="fas fa-plus mr-2" />
          Create New
        </DropdownToggle>
      ) : (
        <DropdownToggle
          tag="i"
          className="fas fa-ellipsis-v text-muted"
          style={{ cursor: 'pointer', fontSize: '14px' }}
          title="Actions"
        />
      )}
      <DropdownMenu right>{renderMenuItems()}</DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default ActionsDropdown;
